
    var riot = require('riot')
    riot.tag2('gb-native-select', '<select ref="selector" onchange="{$select.selectNative}"> <option if="{!$select.default}" value="" selected disabled>{$select.selectLabel()}</option> <option each="{item in $selectable.items}" if="{!item.clear}" riot-value="{$select.itemValue(item)}">{$select.itemLabel(item)}</option> </select>', '', '', function(opts) {
});

    
  


// WEBPACK FOOTER //
// ./src/tags/select/gb-native-select.tag.html